import { useFormikContext } from "formik";

import { FieldLabel, FieldSelect, FieldText, FormRowField } from "@skilitics/designer-ui-components";
import { stringOperators } from "@skilitics/judy";
import { useFormatMessage } from "@skilitics/localization";

import { useTriggerScopeNodeId } from "../../../triggers/HandlerDesignerContext.ts";
import type { ComparisonViewProps, ComparisonFieldValues } from "../../valueSubtypeDefinition.ts";
import { ValueConfigEditor } from "../ValueConfigEditor.tsx";
import { useOperatorOptions } from "./useOperatorOptions.ts";

/** The operator and operand rows of a string comparison. Rows only — a Form mounts it. */
export const StringComparisonView = ({
  scopeNodeId,
  excludeNodeId,
  bindable,
  disabled = false,
}: ComparisonViewProps) => {
  const formatMessage = useFormatMessage(stringComparisonFormatStrings);
  const triggerScopeNodeId = useTriggerScopeNodeId();
  const { values } = useFormikContext<ComparisonFieldValues>();
  const operatorOptions = useOperatorOptions(stringOperators, values.operator);

  return (
    <>
      <FormRowField<ComparisonFieldValues> name="operator">
        <FieldLabel />
        <FieldSelect disabled={disabled} options={operatorOptions} placeholder={formatMessage("operatorPlaceholder")} />
      </FormRowField>

      <FormRowField<ComparisonFieldValues> name="value">
        <FieldLabel />
        <ValueConfigEditor
          type="string"
          scopeNodeId={scopeNodeId ?? triggerScopeNodeId}
          excludeNodeId={excludeNodeId}
          bindable={bindable}
          disabled={disabled}
        >
          <FieldText disabled={disabled} />
        </ValueConfigEditor>
      </FormRowField>
    </>
  );
};

/** Spread into the mounting form's `formatStrings` — an implicit `FieldLabel` reads its text from there. */
export const stringComparisonFormatStrings = {
  operatorLabel: {
    en: "Operator",
  },
  operatorPlaceholder: {
    en: "Select an operator",
  },
  valueLabel: {
    en: "Value",
  },
};
